namespace GeniuzPOS.PosShift {
    export class ReportRecvbyCashierbyDateColumns {
        static columnsKey = 'PosShift.ReportRecvbyCashierbyDate';
    }
}
